<template>
    <div class="app-margin">
        <div>
            <m-incident-app-bar />
            <div style="position: relative; padding-left: 75px">
                <c-inc-todos />

                <v-row class="no-frame">
                    <v-col class="col-12 no-frame bottom-line"></v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>

import MIncidentAppBar from "@/modules/core/components/app/CAppHomeBar";
import CIncTodos       from "@/modules/inc/todos/components/CIncTodos.vue";

export default {
    name: "CAppHome",

    components: {
        CIncTodos,
        MIncidentAppBar,
    },

    computed: {
        reminder () {
            return this.$store.getters.top;
        },
    },

}
</script>

<style scoped>

.app-margin {
    margin-right: 75px;
}

.bottom-line {
    border-top-style: solid;
    border-top-color: black;
    border-top-width: 0;
}

</style>